import { InfoPageParagraphText } from './InfoPageParagraphText.style';

export default InfoPageParagraphText;
